import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['signInClick', 'authErrorShown'] as const;

export const signInEvents = getMappedEvents([...EVENTS]);
